import { trace } from 'owa-trace';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SmartPillData } from 'owa-smart-pill';
import { FeatureNames, SmartTimeConfidenceLevel, SmartTaskConfidenceLevel } from './constants';

export default function isConfidenceScoreAcceptable(pill: SmartPillData): boolean {
    if (pill) {
        //confidence check is not applicable to smart document suggestion yet
        if (pill.featureName === FeatureNames.SmartDoc) {
            return true;
        }

        // log pill extraction id if no confidence level id provided for auditing purpose
        if (pill.confidenceScore == null) {
            trace.info(
                '[isConfidenceScoreAcceptable] confidence score is null. Feature: ' +
                    pill.featureName +
                    ' EntityId: ' +
                    pill.logData.mainPayload.EID
            );
        }
        const pillConfidenceLevel: number = pill.confidenceScore;

        if (pillConfidenceLevel > 0) {
            /**
             * Treats the flights below as an override to the default confidence level check
             * Rules:
             *      1. Outlook will filter pill with the highest (default) confidence score of its type.
             *      2. If (flight: MID or LOW) override turns on, it will take the precendence over the default confidence score.
             *      3. If (flight: MID and LOW) override are on, the lowest confidence score will take the precedence.
             */
            if (isFeatureEnabled('mc-smartPillConfidenceLevel_LOW')) {
                /**
                 * 05/14/2019  when low confidence flight is on, treat it as no confidence check is in placed
                 * */
                return true;
            } else if (isFeatureEnabled('mc-smartPillConfidenceLevel_MID')) {
                switch (pill.featureName) {
                    case FeatureNames.SmartTime:
                        return pillConfidenceLevel >= SmartTimeConfidenceLevel.Mid;
                        break;
                    case FeatureNames.SmartTask:
                    case FeatureNames.SmartTodo:
                        return pillConfidenceLevel >= SmartTaskConfidenceLevel.Mid;
                        break;
                    default:
                        return true;
                }
            } else {
                /* default is to set smart pill confidence level HIGH */
                switch (pill.featureName) {
                    case FeatureNames.SmartTime:
                        return pillConfidenceLevel >= SmartTimeConfidenceLevel.High;
                        break;
                    case FeatureNames.SmartTask:
                    case FeatureNames.SmartTodo:
                        return pillConfidenceLevel >= SmartTaskConfidenceLevel.High;
                        break;
                    default:
                        return true;
                }
            }
        }
    }

    return false;
}
